import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-created',
  template: `
  <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
    <mat-icon>new_releases</mat-icon>
  </div>

  <div class="description">
    <strong *ngIf="activity.meta['leadSource'] !== 'Lendio Marketplace - Revived'">Business Created</strong>
    <strong *ngIf="activity.meta['leadSource'] === 'Lendio Marketplace - Revived'">Business Revived</strong>
    <div class="text"><span *ngIf="activity.meta['leadSource']"> from {{ activity.meta['leadSource'] }},
    </span> assigned to {{ activity.meta['lenderUserName'] }}.</div>
  </div>

  `,
  styles: []
})
export class ActivityRowCreatedComponent {
  @Input() activity;
}
